/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense, lazy, ComponentProps } from "react";
import type CampaignPopup from "./PopUp";

const AsyncComponent = lazy(
  () => import(/* webpackChunkName: "campaign-popup" */ "./PopUp")
);

export default function PopUpLoader(
  props: ComponentProps<typeof CampaignPopup>
) {
  return (
    <Suspense fallback={<div />}>
      <AsyncComponent {...props} />
    </Suspense>
  );
}
